import React from 'react';
import programs from '../programs.json';
import { formatPrice } from '../siteConfig';
import ProgramImage from './ProgramImage';

function ProgramPage() {
    return (
        <section className="welcome-area about-page">
            <div className="container">
                <div className="sec-title text-center">
                    <div className="title">Our Programs</div>
                    <div className="dector center thm-bg-clr"></div>
                </div>
                { programs.map((program) => (
                    <div className="row program-row" key={program.name}>
                        <div className="col-12 col-md-5 col-xl-4">
                            <div className="welcome-right">
                                <div className="video-holder">
                                    <ProgramImage program={program} />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-7 col-xl-8">
                            <div className="health-coacher">
                                <div className="text-box">
                                    <div className="coacher-name">
                                        <h2>{program.name}</h2>
                                    </div>
                                    <div className="coacher-content">
                                        <p>{program.description}</p>

                                        <p><strong>1 Month: &#8377; {formatPrice(program.month1)}/- 3 Months: &#8377; {formatPrice(program.month3)}/-</strong></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>

    )
}

export default ProgramPage
